export const asMenuCollapse = {
  data: `<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0.25L12 0.25V1.75L0 1.75L0 0.25Z" fill="#E8ECED"/>
  <path d="M0 3.25L12 3.25V4.75L0 4.75L0 3.25Z" fill="#E8ECED"/>
  <path d="M0 6.25L12 6.25V7.75L0 7.75L0 6.25Z" fill="#E8ECED"/>
  </svg>`,
  name: 'menucollapse',
};
